var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.047,
    height: 22.428,
    viewBox: "0 0 17.047 22.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-svgrepo-com_4_",
    "data-name": "upload-svgrepo-com (4)",
    transform: "translate(-58.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(58.775 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80176",
    "data-name": "Path 80176",
    d: "M75.822,177.176V168a2.848,2.848,0,0,0-2.843-2.843h-1.84a.563.563,0,0,0,0,1.126h1.84A1.725,1.725,0,0,1,74.7,168v9.183a1.725,1.725,0,0,1-1.721,1.721H61.618a1.725,1.725,0,0,1-1.721-1.721V168a1.725,1.725,0,0,1,1.721-1.721h1.84a.563.563,0,1,0,0-1.126h-1.84a2.848,2.848,0,0,0-2.843,2.843v9.183a2.848,2.848,0,0,0,2.843,2.843H72.98A2.843,2.843,0,0,0,75.822,177.176Z",
    transform: "translate(-58.775 -157.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80177",
    "data-name": "Path 80177",
    d: "M149.063,4.786a.558.558,0,0,0,.792,0L152.739,1.9v10.52a.563.563,0,1,0,1.126,0V1.907l2.884,2.884a.562.562,0,0,0,.8-.792L153.705.158a.575.575,0,0,0-.792,0L149.072,4A.545.545,0,0,0,149.063,4.786Z",
    transform: "translate(-144.774 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8aff79b49c2f9f2344a34a72ce99b004.svg";
export { ForwardRef as ReactComponent };